var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-12" }, [
    _c("p", { staticClass: "guarantees-title fw-bold mb-0" }, [
      _vm._v("\n        " + _vm._s(_vm.title) + "\n    "),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "accordion" },
      _vm._l(_vm.guarantees, function (guarantee, index) {
        return _c("div", { key: "guarantee-" + index }, [
          _c("div", { staticClass: "card multi" }, [
            _c(
              "div",
              {
                staticClass: "card-header",
                attrs: { id: "heading-guarantee-" + index },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "collapsed",
                    attrs: {
                      "data-bs-toggle": "collapse",
                      "data-bs-target": "#guarantee-collapse-" + index,
                      "aria-controls": "#" + "guarantee-collapse-" + index,
                      "aria-expanded": "false",
                    },
                  },
                  [
                    _c("span", { staticClass: "accordion-card-title" }, [
                      _c("span", {
                        staticClass: "accordion-title",
                        domProps: { innerHTML: _vm._s(guarantee.title) },
                      }),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "accordion-icon",
                        attrs: { "aria-hidden": "true" },
                      }),
                    ]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "collapse",
                attrs: {
                  id: "guarantee-collapse-" + index,
                  "aria-labelledby": "guarantee-" + index,
                },
              },
              [
                _c("div", { staticClass: "accordion-card-body standard" }, [
                  guarantee.description
                    ? _c("p", {
                        domProps: { innerHTML: _vm._s(guarantee.description) },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "list mb-0" },
                    _vm._l(guarantee.advantages, function (advantage, pointer) {
                      return _c(
                        "li",
                        { key: "guarantee-advantage-" + pointer },
                        [
                          _c("span", {
                            domProps: { innerHTML: _vm._s(advantage) },
                          }),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
              ]
            ),
          ]),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }